<div class="form-group">
  <div class="label-container">
    <label [attr.for]="label">{{ label }}</label>

    <!-- Conditionally show the Show/Hide toggle button -->
    <label
      class="password-visibility float-end"
      *ngIf="showHideButton"
    >
      <button
        class="btn-password-visibility"
        type="button"
        (click)="togglePasswordVisibility()"
      >
        <span class="password-label">
          {{ showPassword ? 'Hide ' : 'Show ' }}
        </span>
        <img
          [src]="visibilityIcon"
          width="18"
          height="18"
          style="margin-right: 4px;"
        />
      </button>
    </label>
  </div>

  <div class="input-group">
    <input
      [type]="showPassword ? 'text' : 'password'"
      [formControl]="control"
      class="form-control"
      [ngClass]="{
        'is-invalid': control.invalid && control.touched
      }"
      [attr.data-bs-toggle]="tooltip ? 'tooltip' : null"
      data-bs-placement="top"
      [attr.title]="tooltip"
    />
  </div>

  <!-- Display validation messages -->
  <div class="validation-message" *ngIf="control?.touched && control?.invalid">
    <!--
      For each known error type, we check if it's present,
      then display the appropriate error message
    -->
    <div
      *ngIf="hasError('required') && errorMessages['required']"
    >
      {{ errorMessages['required'] }}
    </div>

    <div
      *ngIf="hasError('minlength') && errorMessages['minlength']"
    >
      {{ errorMessages['minlength'] }}
    </div>

    <div
      *ngIf="hasError('maxlength') && errorMessages['maxlength']"
    >
      {{ errorMessages['maxlength'] }}
    </div>

    <div
      *ngIf="hasError('pattern') && errorMessages['pattern']"
    >
      {{ errorMessages['pattern'] }}
    </div>

    <div
      *ngIf="hasError('containsSpaces') && errorMessages['containsSpaces']"
    >
      {{ errorMessages['containsSpaces'] }}
    </div>

    <!-- For any other errors, you can handle them similarly,
         or provide a fallback message if you'd like.
         e.g.
         <div *ngIf="control?.errors">
           An unknown error occurred
         </div>
    -->
  </div>
</div>
